import { render, staticRenderFns } from "./ExclusionManage.vue?vue&type=template&id=6da0d324&"
import script from "./ExclusionManage.vue?vue&type=script&lang=js&"
export * from "./ExclusionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports